let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jdMF4")).then(() => parcelRequire('kPUCC'));